<template>
  <card>
    <template slot="header">
      <!-- Title -->
      <h5 class="h3 mb-0">RESULTADO DA AVALIAÇÃO</h5>
    </template>
    <div v-loading="loading">
      <div :style="{ height: `${height}px` }">
        <strong>Quantidade de Perguntas:</strong> {{ (chartData.qtd_items || 0).toLocaleString('pt-BR') }}<br/>
        <strong>Quantidade de Respostas:</strong> {{ (chartData.qtd_answers || 0).toLocaleString('pt-BR') }}<br/>
        <strong>Resultado Final:</strong> {{ (chartData.avg || 0).toLocaleString('pt-BR') }}<br/>
      </div>
    </div>
  </card>
</template>

<script>

export default {
  name: 'avaliationResultCard',
  props: {
    avaliation: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 110,
    },
  },
  data: () => ({
    loading: false,
    chartData: {},
  }),
  mounted() {
    this.getChartData();
  },
  methods: {
    async getChartData() {
      this.loading = true;
      try {
        const { data } = await this.$http.secured.get(`/api/v1/avaliations/${this.avaliation.id}/avaliation_result_data`);
        this.chartData = data;
      } catch (error) {
        console.error("[avaliationResultCard][getChartData] Error getting chart data", error)
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    avaliation() {
      this.getChartData();
    },
  },
}
</script>
